import { get } from "../../helpers/apiWrapper";

export const getAppliedjobs = async (params) => {
    const config = {
      params: params,
    };
    return await get(`/applied-jobs`, config);
  };
  